import React, { FunctionComponent } from 'react';
import { useSelector } from 'react-redux';
import { getCustomiseSelectedSection } from '../../store/selectors/customiseSelectors';
import carConfigurationSelectors from '../../store/selectors/carConfigurationSelectors';
import useCustomisedConfiguration from '../../react/useCustomisedConfiguration';
import CustomiseLayout from './layout/CustomiseLayout';
import { getPostCodeModalContext, IPostCodeContext, PostCodeContext } from '../../../common/react/PostCodeContext';
import useFetchCurrentDeal from '../../react/useFetchCurrentDeal';
import useVariantList from '../../react/useVariantList';
import {
  FinCalcSpcContext,
  getFinCalcSpcContextValue,
  IFinCalcSpcContext,
} from '../../../common/react/FinCalcSpcContext';
import useUpdateWidgetPadding from '../../react/useUpdateWidgetPadding';
import withFreshStore from '../../../common/react/withFreshStore';
import useScrollToWidgetTop from '../../../common/react/useScrollToWidgetTop';
import useUpdateSEO from '../../../customise/react/useUpdateSEO';
import TestAutomationData from './automationData/TestAutomationData';

const CustomiseContainer: FunctionComponent = () => {
  useScrollToWidgetTop();
  useFetchCurrentDeal();
  useCustomisedConfiguration();
  useVariantList();
  useUpdateWidgetPadding();

  const postCodeContext: IPostCodeContext = getPostCodeModalContext();
  const finCalcSpcContextValue: IFinCalcSpcContext = getFinCalcSpcContextValue();
  const step = useSelector(getCustomiseSelectedSection);
  const model: string = useSelector(carConfigurationSelectors.getConfigurationModelTitle);
  const variant: string = useSelector(carConfigurationSelectors.getConfigurationTitle);

  useUpdateSEO({
    title: 'spc.seo.configuratorPage.title',
    description: 'spc.seo.configuratorPage.description',
    model,
    variant,
    step,
  });

  return (
    <PostCodeContext.Provider value={postCodeContext}>
      <FinCalcSpcContext.Provider value={finCalcSpcContextValue}>
        <CustomiseLayout />
        <TestAutomationData />
      </FinCalcSpcContext.Provider>
    </PostCodeContext.Provider>
  );
};

export default withFreshStore(CustomiseContainer);
